import React, { useEffect, useState } from "react"
import DescriptionCategoryProducts from "../../atoms/description-category-events/description-category-events"
import EventsFilters from "../../molecules/events-filters/events-filters"
import EventCard from "../../../shared/components/molecules/event-card/event-card"
import EventCardArticle from "../../../shared/components/molecules/event-card-article/event-card-article"
import LeafaletCard from "../../../shared/components/molecules/leaflet-card/leaflet-card"
import SeoProductInfo from "../../../shared/components/molecules/seo-product-info/seo-product-info"
import Button from "../../../shared/components/atoms/Button/Button"
import useSession from "../../../shared/hooks/useSessionState"
import useMobileMode from "../../../shared/hooks/useMobileMode"
import { replaceAccent, jsUpperCasefirst } from "../../../shared/state/utils/utilities-string";
import WebinarService from "../../../shared/services/webinar"
import Loader from 'react-loader-spinner'
import Img from "gatsby-image";
import "./events-content.scss"
import useLocaleMode from "../../../shared/hooks/useLocaleMode"

const GRID_TITLE = {
  "es-CO": "CONTENIDO DISEÑADO PARA TI",
  "es-AR": "CONTENIDO DISEÑADO PARA VOS"
}

const EventsContent = ({ events, sectionInfo, academyInfo }) => {
    const { locale } = useLocaleMode()
    const { isMobile } = useMobileMode()
    const [isLoading, setIsLoading] = useState(true)
    const { isLoggedUser } = useSession()
    const bannerInfo = sectionInfo?.bannerCategoria || sectionInfo?.bannerPrincipal[0]
    const principalInformation = sectionInfo?.informacinPrincipal || sectionInfo?.informacionPrincipal || null
    const gridTitleByLocale = GRID_TITLE[locale] || GRID_TITLE["es-CO"]

    const [filteredEvents, setFilteredEvents] = useState(events || [])
    const [showMoreList, setShowMoreList] = useState(events)
    const [elementsToShow, setElementToShow] = useState(6)

    const filterCategoryValues = getFilterValues(academyInfo.filtroCategoria || [], true)
    const filterFormatValues = getFilterValues(academyInfo.filtroFormato || [])
    const filterInterestValues = getFilterValues(academyInfo.filtroTemasDeInteres || [])
    const filterManagedValues = getFilterValues(academyInfo.filtroDirigidoA || [])
    const filterContentValues = getFilterValues(academyInfo.filtroTipoDeContenido || [])

    //filter actives
    const defaltActiveCategory = {
        [jsUpperCasefirst(sectionInfo.nombreDeEtiqueta || "Todos")]: 
        replaceAccent(jsUpperCasefirst(sectionInfo.nombreDeEtiqueta || "Todos")),
    }
    const [filterCategory, setFilterCategory] = useState(defaltActiveCategory)
    const [filterFormat, setFilterFormat] = useState({})
    const [filterInterest, setFilterInterest] = useState({})
    const [filterManaged, setFilterManaged] = useState({})
    const [filterContent, setFilterContent] = useState({})

    const FILTERS_INFO = [
      academyInfo.tieneFiltroCategoria
        ? {
            filterName: "Categoría...",
            filterValues: filterCategoryValues,
            filterState: filterCategory,
            onChangeFilter: value =>
              handleChangeProperty(filterCategory, setFilterCategory, value),
          }
        : {
            filterName: "Temas de interés...",
            filterValues: filterInterestValues,
            filterState: filterInterest,
            onChangeFilter: value =>
              handleChangeProperty(filterInterest, setFilterInterest, value),
          },
      {
        filterName: "Formato...",
        filterValues: filterFormatValues,
        filterState: filterFormat,
        onChangeFilter: value =>
          handleChangeProperty(filterFormat, setFilterFormat, value),
      },
      {
        filterName: "Dirigido a...",
        filterValues: filterManagedValues,
        filterState: filterManaged,
        onChangeFilter: value =>
          handleChangeProperty(filterManaged, setFilterManaged, value),
      },
      {
        filterName: "Tipo de contenido...",
        filterValues: filterContentValues,
        filterState: filterContent,
        onChangeFilter: value =>
          handleChangeProperty(filterContent, setFilterContent, value),
      },
    ]

    const onClearFilters = () => {
        setFilterFormat({})
        setFilterInterest({})
        setFilterManaged({})
        setFilterContent({})
    }

    const orderElementByViews = (dataService, arrInfo = events) => {
        let eventsWithViews = arrInfo.reduce((acc, event) => {
            let resultFind = dataService.find(serviceEvent =>
                serviceEvent.cmsId === event.identificadorEvento ||
                serviceEvent.cmsId === event.id ||
                serviceEvent.cmsId === event.contentful_id
            )
            acc.push({ ...event, read: resultFind ? resultFind.read : 0 })
            return acc
        }, [])

        //sort by views
        eventsWithViews.sort((event1, event2) => {
            let event1State = event1.estadoWebinar?.toLowerCase()
            let event2State = event2.estadoWebinar?.toLowerCase()

            return event1State && event1State !== "finalizado el evento" ? -1 :
                event2State && event2State !== "finalizado el evento" ? 1 :
                    event1.read > event2.read ? -1 : event2.read > event1.read ? 1 : 0
        })

        return eventsWithViews
    }

    const handleShowMore = () => {
        let elementsToShowCopy = elementsToShow + 6
        setShowMoreList([...filteredEvents.slice(0, elementsToShowCopy)])
        setElementToShow(elementsToShowCopy)
    }

    const handleChangeProperty = (filterValues, setter, value) => {
        if (!filterValues?.hasOwnProperty(value.key)) {
            setter(
                filterValues
                    ? { ...filterValues, [`${value.key}`]: value.value }
                    : { [`${value.key}`]: value.value }
            )
        } else {
            setter(state => {
                const clonendState = JSON.parse(JSON.stringify(state))
                delete clonendState[value.key]
                return clonendState
            })
        }
    }

     //get filter keys
    function getFilterValues(array, isRedirectionFilter = false) {
        return array.reduce(
            (acc, el) => {
                let option = {
                    name: jsUpperCasefirst(el.nombreDeEtiqueta),
                    value: replaceAccent(jsUpperCasefirst(el.nombreDeEtiqueta)),
                }
                el.slug &&
                    (option.slug = `/academia-tena/${el.slug !== "/" ? el.slug : ""}`)
                acc.push(option)
                return acc
            },
            [{
                name: "Todos",
                value: "Todos",
                slug: isRedirectionFilter ? "/academia-tena/" : null
            }]
        )
    }

    useEffect(() => {
        setIsLoading(true)

        const newEvents = events.filter(el => {
            return (
                (Object.keys(filterFormat).length === 0 ||
                    filterFormat.hasOwnProperty("Todos") ||
                    Object.keys(filterFormat).some(filter => el.eventFormat.includes(filter.toLowerCase()))
                ) &&
                (Object.keys(filterInterest).length === 0 ||
                    filterInterest.hasOwnProperty("Todos") ||
                    Object.keys(filterInterest).some(filter => el.eventThemes.includes(filter.toLowerCase()))
                ) &&
                (Object.keys(filterManaged).length === 0 ||
                    filterManaged.hasOwnProperty("Todos") ||
                    Object.keys(filterManaged).some(filter => el.eventManaged.includes(filter.toLowerCase()))
                ) &&
                (Object.keys(filterContent).length === 0 ||
                    filterContent.hasOwnProperty("Todos") ||
                    Object.keys(filterContent).some(filter => el.eventContentType.includes(filter.toLowerCase()))
                )
            )
        })

        let newOrderedByViews = orderElementByViews([], newEvents)
        setFilteredEvents(newOrderedByViews)
        setShowMoreList(newOrderedByViews.slice(0, elementsToShow))

        setTimeout(() => {
            setIsLoading(false)
        }, 300);
    }, [filterFormat, filterInterest, filterManaged, filterContent])

    useEffect(() => {
        WebinarService.getViews().then(res => {
            if (res.status === 200) {
                let orderedByViews = orderElementByViews(res.data)
                setFilteredEvents(orderedByViews)
                setShowMoreList(orderedByViews.slice(0, elementsToShow))
            }
        }).catch(err => {
            console.log("Error consultando vistas", err)
        })
    }, [])

    useEffect(() => {
      localStorage.setItem("previousPageRegister", "fromAcademia")
    }, [])

    return (
      <div className="f-events">
        <div className="f-events__banner">
          <Img
            className="f-events__banner__image"
            fluid={
              bannerInfo[isMobile ? "bannerMobile" : "bannerDesktop"]?.fluid
            }
            alt={
              bannerInfo[isMobile ? "bannerMobile" : "bannerDesktop"]
                ?.description
            }
          />
        </div>

        <div className="f-events__content">
          <EventsFilters
            filtersInfo={FILTERS_INFO}
            onClearFilters={onClearFilters}
          />

          {principalInformation && (
            <DescriptionCategoryProducts
              generalDescription={principalInformation}
            />
          )}

          <h2 className="f-events-container__title">
            {gridTitleByLocale}
          </h2>

          {isLoading && (
            <Loader
              className="f-events__loader"
              type="Oval"
              color="#003784"
              height={50}
              width={50}
            />
          )}

          <div
            className={`f-events-container ${
              isLoading ? "f-events-container--hidde" : ""
            }`}
          >
            <div className="f-events-container__grid">
              {showMoreList.map((event, index) => {
                if (event.id) {
                  return <EventCardArticle article={event} key={index} />
                } else {
                  return <EventCard event={event} key={index} />
                }
              })}
            </div>

            {elementsToShow < filteredEvents.length && (
              <div className="f-events-container__show-more">
                <Button
                  type="button"
                  text="CARGAR MÁS"
                  onClickAction={handleShowMore}
                  classname="f-button f-button--primary"
                />
              </div>
            )}
          </div>

          <div className="f-events-leafalet">
            {!isLoggedUser && <LeafaletCard isMobile={isMobile} />}
          </div>
        </div>

        {sectionInfo.informacionAdicional && (
          <SeoProductInfo
            seoInfo={sectionInfo.informacionAdicional}
            customClass="f-events__seo-info"
          />
        )}
      </div>
    )
}

export default EventsContent
